import React from 'react';
import { Shield, Star, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="min-h-[100dvh] md:min-h-screen bg-gradient-to-b from-black via-[#1A1A1A] to-[#141414] py-[14px] md:pt-8 md:pb-16 px-5 md:px-4 flex flex-col justify-evenly md:justify-center" data-id="element-100">
      <div className="max-w-6xl mx-auto w-full flex flex-col md:block" data-id="element-101">
        {/* 1. Logo — 13px mobile */}
        <p className="text-soft-gold font-bold tracking-widest text-[13px] md:text-sm text-center mb-1 md:mb-6 uppercase" data-id="element-102">
          💪 NEROVIX™
        </p>

        {/* 2. Headline — 26px mobile, lh 1.15 */}
        <div className="text-center mb-1 md:mb-8" data-id="element-103">
          <h1 className="text-[26px] md:text-5xl font-playfair font-bold text-white leading-[1.15] md:leading-tight" data-id="element-104">
            The difference between a PT who makes it —
          </h1>
          <h2 className="text-[26px] md:text-5xl font-playfair font-bold text-soft-gold leading-[1.15] md:leading-tight" data-id="element-105">
            and one who quits.
          </h2>
        </div>

        {/* 3. Mockup — 32vh mobile */}
        <div className="relative max-w-3xl mx-auto my-1 md:mb-8" data-id="element-106">
          <div className="absolute inset-0 bg-soft-gold/20 blur-[80px] rounded-full" data-id="element-107"></div>
          <img src="https://cdn.magicpatterns.com/uploads/iqYt6Z98kV2R8DZ6kt6QxP/PT_BUSINESS__COACHING_KIT.png" alt="NEROVIX PT Business & Coaching Kit" className="relative z-10 w-full max-h-[38vh] md:max-h-[60vh] object-contain drop-shadow-[0_0_30px_rgba(212,175,55,0.3)]" data-id="element-108" />
        </div>

        {/* 4. "#1 system" line — 12px mobile, single line */}
        <p className="text-soft-gold text-[12px] md:text-lg font-bold text-center mb-1 md:mb-4" data-id="element-109">
          #1 system for Personal Trainers & Fitness Coaches in NZ/AU
        </p>

        {/* 5. Subtext paragraph — 12px mobile, lh 1.3 */}
        <p className="text-white text-[12px] md:text-base text-center leading-[1.3] md:leading-relaxed mb-1 md:mb-8" data-id="element-110">
          Most PTs quit within 2 years. Not because they can't train. Because
          they never built a real business.
        </p>

        {/* 6. Badges — 10px, single row, no wrap */}
        <div className="flex justify-center gap-1 md:gap-3 mb-[6px] md:mb-8 flex-nowrap" data-id="element-111">
          <div className="bg-nero-mid border border-nero-border px-[6px] py-1 md:px-3 md:py-1.5 rounded-full flex items-center gap-1 md:gap-2" data-id="element-112">
            <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4 text-soft-gold shrink-0" data-id="element-113" />
            <span className="text-soft-gold text-[10px] md:text-xs font-medium whitespace-nowrap" data-id="element-114">
              Instant Access
            </span>
          </div>
          <div className="bg-nero-mid border border-nero-border px-[6px] py-1 md:px-3 md:py-1.5 rounded-full flex items-center gap-1 md:gap-2" data-id="element-115">
            <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4 text-soft-gold shrink-0" data-id="element-116" />
            <span className="text-soft-gold text-[10px] md:text-xs font-medium whitespace-nowrap" data-id="element-117">
              NZ/AU Specific
            </span>
          </div>
          <div className="bg-nero-mid border border-nero-border px-[6px] py-1 md:px-3 md:py-1.5 rounded-full flex items-center gap-1 md:gap-2" data-id="element-118">
            <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4 text-soft-gold shrink-0" data-id="element-119" />
            <span className="text-soft-gold text-[10px] md:text-xs font-medium whitespace-nowrap" data-id="element-120">
              100% Editable
            </span>
          </div>
        </div>

        {/* 7. CTA Button — 52px height, 17px text, full width */}
        <a href="#pricing" className="w-full md:w-auto md:mx-auto md:px-12 h-[52px] bg-soft-gold hover:bg-dark-gold text-black text-[17px] md:text-xl font-bold rounded-[10px] md:rounded-xl shadow-[0_0_20px_rgba(212,175,55,0.4)] transition-all transform hover:scale-105 flex items-center justify-center gap-2 mb-[6px] md:mb-6 no-underline" data-id="element-121">
          💪 → I WANT MY MEGAPACK NOW
        </a>

        {/* 8. Trust line — 11px, single line */}
        <div className="flex items-center justify-center gap-4 text-secondary-text text-[11px] md:text-xs" data-id="element-122">
          <div className="flex items-center gap-1" data-id="element-123">
            <Shield className="w-3 h-3 md:w-4 md:h-4" data-id="element-124" />
            <span data-id="element-125">Secure Checkout</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-126">
            <div className="flex" data-id="element-127">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-128" />)}
            </div>
            <span data-id="element-129">4.9/5 Rating</span>
          </div>
        </div>
      </div>
    </section>;
}